// import logo from "./avatar.svg";
import "react-chat-widget/lib/styles.css";
import Chatbot from './chatbot/Chatbot';

function App() {
  return (
    <div className="App">
      <Chatbot
        chatTitle="Live Chat Support"
        apiURL = "/umbraco/api/chatbot/sendmessage"
        companyId = "1"

        // “1” for RifTrust or ”2” for Lattitude World.
        // apiURL="https://chatbot-node-api-1.herokuapp.com/api/chatbots"
      />
    </div>
  );
}

export default App;
